import {
  getProblemsHome,
  // getListCategory,
  getDetailProblem,
  getCategory
} from "./../api.js";

export const state = {
  categoriesResponse: {},
  getProblemsHome: {},
  getDetailProblem: {},
  categories: {}
};

export const getters = {
  categories: state =>
    state.categoriesResponse.data ? state.categoriesResponse.data : [],
  problems: state =>
    state.getProblemsHome.data ? state.getProblemsHome.data : [],
  pagination: state => state.getProblemsHome,
  detailProblem: state =>
    state.getDetailProblem.data ? state.getDetailProblem.data : []
};

export const mutations = {
  getListCategory(state, data) {
    state.categoriesResponse = data;
  },
  getProblems(state, data) {
    state.getProblemsHome = data;
  },
  getDetail(state, data) {
    state.getDetailProblem = data;
  }
};

export const actions = {
  async getListCategoryTest({ commit }, query) {
    let data = await getCategory(query);
    commit("getListCategory", data);
  },
  async getProblems({ commit }, query) {
    let data = await getProblemsHome(query);
    commit("getProblems", data);
  },
  async getDetail({ commit }, query) {
    let data = await getDetailProblem(query);
    commit("getDetail", data);
  }
};
